/* unplugin-vue-components disabled */import { render } from "./badge.vue?vue&type=template&id=e04e13ba&scoped=true"
import script from "./badge.vue?vue&type=script&lang=js"
export * from "./badge.vue?vue&type=script&lang=js"

import "./badge.vue?vue&type=style&index=0&id=e04e13ba&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e04e13ba"],['__file',"src/controls/badge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e04e13ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e04e13ba', __exports__)) {
    api.reload('e04e13ba', __exports__)
  }
  
  module.hot.accept("./badge.vue?vue&type=template&id=e04e13ba&scoped=true", () => {
    api.rerender('e04e13ba', render)
  })

}


export default __exports__